import Card from "../components/posPage/card";
import '../style/pages/pos.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { FreeMode } from "swiper/modules";
import OrderBar from "../components/posPage/orderBar";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { context } from "../context/context";
import Scroll from "../components/global/Pagination";
import { countStore, mainSearch, secondarySearch, semiSearch } from '../components/indexDB/indexDBStora'; 
import { InvoiceData } from "../funcs/invoiceData";
import { config } from "../context/config";
import { dataa } from "../context/data";
import { extractWeight } from "../funcs/extractWeight";
import { useDebounce } from "../funcs/hooks/useDebounce";
import Empty from "../components/empPage/empty";
import { Setting } from "../context/settings";
import { switchh } from "../context/switch";
import { auth } from "../context/auth";
import Loading from "../components/global/Loading";
import { CalcDiscount } from "../funcs/calcDiscount";

export default function POS() {
    const { stylingNav, page, hide, setHide } = useContext(config);
    const { category, showData, setShowData } = useContext(dataa);
    const { storeConfig } = useContext(Setting);
    const { serial, setSerial, setCart, cart, addOne, setAddOne, product, setProduct, search, catChoose, setCatChoose } = useContext(context);
    const { enableReturns, loadingDebounce, setLoadingDebounce }= useContext(switchh);
    const {user} = useContext(auth);
    const [totalPages,setTotalPages] = useState(1);

    const nextId = useMemo(() => {
        const maxId = Math.max(
            0,
            ...cart.filter(Boolean).map(item => item.id || 0)
        );

        return maxId + 1;
    }, [cart]);

    const collect = useMemo(() => {
        if (!product) return null;
        return InvoiceData(
            nextId,
            product.prod_id,
            product.barcode,
            product.nameProudct,
            product.sellPrice,
            product.quantity,
            product.type,
            product.discount,
            product.inventoryId
        );
    }, [product, nextId]);
    
    const addToCart = useCallback(() => {
    if (!product || !addOne || !collect) return;

    setCart(prev => {
        const exists = prev.find(item => item.barcode === product.barcode);

        if (exists && exists.measure === "unit") {
            return prev.map(item => {
                if (item.barcode === product.barcode) {
                    const newQuantity = item.quantity + 1;

                    const calculate = CalcDiscount(
                        item.discount,
                        newQuantity,
                        item.price
                    );

                    return {
                        ...item,
                        quantity: newQuantity,
                        amount: calculate.result
                    };
                }

                return item;
            });
        }

        return [...prev, collect];
    });

    setProduct({});
    setSerial("");
    setAddOne(false);
}, [product, addOne, collect, setCart]);

    useEffect(() => {
    addToCart();
    }, [addToCart]);

    const debounceSerial = useDebounce(serial.code, 100);

    useEffect(() => {
    if (!debounceSerial) return;

    setCatChoose("");

    const extractCD = (code) => code.slice(-1);

    const getSerial = async () => {
        let productData = null;

        // البحث عن منتج عادي
        const normalProducts = await secondarySearch(
            "products",
            "barcode",
            debounceSerial
        );
        const normalProduct =
        normalProducts?.length > 0
        ? normalProducts[0]
        : null;
        
        if (normalProduct?.type === "unit") {
            productData = {
                prod_id: normalProduct.id,
                barcode: normalProduct.meta.barcode,
                nameProudct: normalProduct.nameProudct,
                quantity: 1,
                sellPrice: normalProduct.sellPrice,
                amount: normalProduct.sellPrice,
                type: normalProduct.type,
                discount: normalProduct.discount,
                inventoryId: normalProduct.inventoryId
            };

            setProduct(productData);
            return;
        }

        // البحث عن منتج وزن
        const prefixLength = serial?.prefix?.length;
        const pureCode = debounceSerial.slice(prefixLength, -6);

        const weightProducts = await secondarySearch(
            "products",
            "barcode",
            pureCode
        );
        if (!weightProducts?.length) return;
        
        const weightProduct = weightProducts[0];
        
        if (weightProduct.type === "unit") return;

        const weight = extractWeight(debounceSerial);
        const cd = extractCD(debounceSerial);

        productData = {
            prod_id: weightProduct.id,
            barcode: debounceSerial,
            nameProudct: weightProduct.nameProudct,
            quantity: weight,
            sellPrice: weightProduct.sellPrice,
            amount: Number(
                (weightProduct.sellPrice * weight).toFixed(2)
            ),
            type: weightProduct.type,
            discount: weightProduct.discount,
            inventoryId: weightProduct.inventoryId
        };
        setProduct(productData);
    };

    getSerial();
}, [debounceSerial]);

    const debounceSearch = useDebounce(search.value, 600);
    useEffect(() => {
        if(catChoose !== '') {
            const products= [];
            const getProducts = async () => {
                    const get_serial = await secondarySearch("products", "categoryID", catChoose, page, 5);
                    get_serial
                    .map((product) => 
                        products.push(product)
                    )
                    setShowData(products)
                }
                getProducts();
            }
            else {
                const getProducts = async () => {
                    if(search.value === "") {
                        setShowData([]);
                        return;
                    }
                    let getProducts;
                    if(search.bySearial) {
                        getProducts = await mainSearch("products", debounceSearch);
                        if(!getProducts) getProducts = [];
                        else getProducts = [getProducts];
                    }
                    else {
                        getProducts = await semiSearch("products",debounceSearch, "nameProudct");
                    }
                    setShowData(getProducts)
                }
                getProducts();
            }
            setLoadingDebounce(false);
    }, [catChoose, page, debounceSearch])


    useEffect(() => {
        if(storeConfig.length === 0) return;

        if(storeConfig.workWay === "barcode") {
            setHide((prev)=>({...prev, serial: true, cat: false}))
        }
        else if(storeConfig.workWay === "category") {
            setHide((prev)=>({...prev, serial: false, cat: true}))
            
        }
        else {
            setHide((prev)=>({...prev, serial: true, cat: true}))
        }
    }, [storeConfig.workWay])

    useEffect(() => {
        const getTotalPages = async (pagination) => {
            const total = await countStore("products");
            const totalPagesIs = Math.ceil(total / pagination);
            setTotalPages(totalPagesIs);
        }
        // total pagination
        getTotalPages(5);
    }, [])
    return (
        <div className={`pos page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            {category.length ? 
            <>
                {hide.cat && !enableReturns.order &&
                <div className="display-product">
                    <div className="parent-cat">
                    <Swiper
                        spaceBetween={50}
                        slidesPerView={category && category.length <= 3 ? category.length : 4}
                        freeMode={true}
                        modules={[FreeMode]}
                        >
                        {category && category.map((item, i) => (
                            <SwiperSlide key={i}>
                                <button onClick={() => setCatChoose(item.id)}>{item.name}</button>
                            </SwiperSlide>
                            ))}
                    </Swiper>
                    </div>
                    {loadingDebounce ? 
                        <Loading />
                        :
                        <div className="parent-products">                 
                            {
                            showData.map((e,i) => 
                                <Card
                                    key={i}
                                    id={e.id}
                                    title={e.nameProudct}
                                    barcode={e.meta.barcode}
                                    price={e.sellPrice}
                                    type={e.type}
                                    discount={e.discount}
                                    isManual={storeConfig.weightManualMode}
                                    currency={user.data[0]?.currency?.code}
                                    flagInv={e.inventoryId}
                                />
                            )}
                        </div>
                    }
                    <Scroll max={totalPages} />
                </div>
                }
                <OrderBar />
            </>
            :
            <Empty mode="pos" />
        }
        </div>
    )
}